import { makeStyles } from "@material-ui/core/styles";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import { RefObject, useEffect, useState } from "react";
import { useAppState } from "../../../../../../../../common/appState";
import { fetchPost } from "../../../../../../../../common/util/fetch";
import { User } from "../../../../../../../shared/User/types";
import { InitialView } from "../../../MyPageTop/types";
import { OpenableCard } from "../OpenableCard";
import { ItemList } from "./ItemList/List";
import { setItemsFromServerSide } from "./items";
import { ItemKey, PossessedItem_ServerSide } from "./items/types";

const cardId = "MyPageItemsCard";

export function ItemsCard({
    user,
    initialView,
    scrollableContainerRef,
    itemKeyToFocus,
}: {
    user: User;
    initialView?: InitialView;
    scrollableContainerRef: RefObject<HTMLDivElement>;
    itemKeyToFocus?: ItemKey;
}) {
    const [open, setOpen] = useState(false);
    const [possessedItems] = useAppState("items");
    const { itemCount, exclamationMark } = possessedItems.reduce(
        (acc, item) => ({
            itemCount: acc.itemCount + item.num,
            exclamationMark: acc.exclamationMark || item.isNew || item.isAdded,
        }),
        { itemCount: 0, exclamationMark: false }
    );

    useEffect(() => {
        if (!open) {
            return;
        }
        if (!possessedItems.some(item => item.isNew || item.isAdded)) {
            return;
        }
        fetchItemSeen(
            user.userId,
            possessedItems.map(({ item }) => item.key)
        );
    }, [possessedItems, open, user]);

    const c = useStyles();

    return (
        <OpenableCard
            title={
                <span>
                    Items: <span className={c.titleNumber}>{itemCount}</span>
                </span>
            }
            icon={<BusinessCenterIcon />}
            saveKey={cardId}
            id={cardId}
            open={open}
            setOpen={setOpen}
            alwaysShowIcon
            alwaysShowTitle
            initiallyOpenedId={initialView}
            scrollableContainerRef={scrollableContainerRef}
            exclamationMark={exclamationMark}
        >
            <ItemList
                possessedItems={possessedItems}
                itemKeyToFocus={itemKeyToFocus}
                user={user}
            />
        </OpenableCard>
    );
}
const useStyles = makeStyles(theme => ({
    titleNumber: { color: theme.palette.success.dark },
}));

async function fetchItemSeen(userId: number, originalOrderedKeys: ItemKey[]) {
    const items = await fetchPost<number, PossessedItem_ServerSide[]>(
        "api/Item/SetItemSeen",
        userId
    );
    if ("error" in items) {
        return;
    }
    setItemsFromServerSide(items, originalOrderedKeys);
}
